import React from 'react'
import { Redirect } from 'react-router-dom'
import { usePoolView } from './use-pool-view'
import PageWrapper from '../PageWrapper'
import Loading from '../Loading'

/**
 * Redirige a la página de la quiniela.
 * desde la ruta /quiniela/:id? y reridige al lobby de la quiniela.
 * @param {Object} match - El objeto match de react-router-dom.
 * @param {Object} match.params - Los parámetros de la URL.
 * @param {string} match.params.id - El ID de la quiniela.
 */

export const RedirectPool = ({ match }) => {
  const poolId = match.params.id 

  const { data, isLoading, error } = usePoolView(poolId)
    if (isLoading) return (
    <PageWrapper>
      <Loading />
    </PageWrapper>
  )

  if (error) return (
    <PageWrapper>
      <div>Error: {error.message}</div>
    </PageWrapper>
  )

  return <Redirect to={`/quiniela/${data.pool.slug}/${data.pool.id}`} />
}
